<template>
    <section>
        <div id="dashboard">
            <Tab/>
        </div>
    </section>
</template>

<script>
    import Tab from './Tab'
    import {Upgrade} from './dashboard/modal'
    import mixins from '../modules/mixins'

    export default {
        name: 'dashboard',
        components: {
            Tab,
            Upgrade
        },
        mixins: [mixins]
    }
</script>

<style>
    .alert.in {
        z-index: 100000;
    }
</style>
